export function getReadableTextColor(backgroundColor) {
  const fallback = '#111827';
  const hex = backgroundColor?.replace('#', '').trim();

  if (!hex || ![3, 6].includes(hex.length)) {
    return fallback;
  }

  const normalized =
    hex.length === 3
      ? hex
          .split('')
          .map((char) => `${char}${char}`)
          .join('')
      : hex;

  const red = parseInt(normalized.slice(0, 2), 16);
  const green = parseInt(normalized.slice(2, 4), 16);
  const blue = parseInt(normalized.slice(4, 6), 16);

  if ([red, green, blue].some((value) => Number.isNaN(value))) {
    return fallback;
  }

  const luminance = (0.2126 * red + 0.7152 * green + 0.0722 * blue) / 255;
  return luminance > 0.58 ? '#111827' : '#f9fafb';
}
